
import ReceiveAward from './components/receiveAward.vue'
import { getPrizeInfo, setViewed } from '@/api/sdws.js'
import { reactive } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
import { ref, watch } from 'vue'
import { Overlay, Loading } from 'vant'
import ChooseReward from './components/chooseReward.vue'
import { useCommonUserRankInfoEffect } from '@/effects/sdwsEffect.js'
import { useStore } from 'vuex'

export default {
  components: {
    ReceiveAward,
    Overlay,
    ChooseReward,
    Loading,
  },
  setup() {
    useViewedEffect()

    const { showReceive, handleReceived } = useReceiveRewardEffect()

    const { prizeInfo, loading, fetchPrizeInfo } = usePrizeInfoEffect()

    // 选择奖品
    const { showReward, handleChooseReward } =
      useShowChooesRewardEffect(fetchPrizeInfo)
    const { handleBtnClick } = useBtnClickEffect(showReward, showReceive)

    const { user } = useCommonUserRankInfoEffect()

    return {
      handleBtnClick,
      prizeInfo,
      showReward,
      handleReceived,
      handleChooseReward,
      showReceive,
      loading,
      user,
    }
  },
}

// 设置查看过
const useViewedEffect = () => {
  const store = useStore()

  const setView = async () => {
    const res = await setViewed()

    console.log('res', res)
  }

  // 活动结束后调用
  if (store.getters.getQuesInfo?.status === 6) {
    setView()
  }
}

// 点击事件
const useBtnClickEffect = (showReward, showReceive) => {
  const router = useRouter()

  const handleBtnClick = (type) => {
    // 没通关，回首页
    if (type === 1) {
      router.go(-1)
    }
    // 没选择心愿
    if (type === 2) {
      showReward.value = true
    }
    //
    if (type === 'receiveAward') {
      showReceive.value = true
    }
  }

  return {
    handleBtnClick,
  }
}

// 获取奖品信息
const usePrizeInfoEffect = () => {
  const loading = ref(true)
  const store = useStore()
  const prizeInfo = reactive({
    status: 1, // 1未通过 2已通关未选择心愿 3待颁奖（已选择星愿，没到开奖时间） 4得奖 5领奖 6未中奖
    prize: '',
    img: require('@/assets/img/sdws/reward.png'),
    prizeTips: '',
  })

  const route = useRoute()

  const fetchPrizeInfo = async () => {
    loading.value = true
    const res = await getPrizeInfo({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken,
    })

    if (res.ok && res.data) {
      prizeInfo.status = res.data.status
      prizeInfo.prize = res.data.prize

      if (res.data.prize?.indexOf('趵突泉') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/28945d923031cf79592b332da2c6cff6.png'
        prizeInfo.prizeTips = '门票一张,有效期一年'
      }
      if (res.data.prize?.indexOf('黄河口') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/ba2de92cf50fc76241ca985f106b0436.png'
        prizeInfo.prizeTips = '门票一张,有效期一年'
      }
      if (res.data.prize?.indexOf('龙口南山景区') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/c21d91a5e5e1e4f5c1f6bea4d1af1c64.png'
        prizeInfo.prizeTips = '门票一张,有效期一年'
      }
      if (res.data.prize?.indexOf('青州古城') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/29aa9862eeeef5b8a109daf6b9756c87.png'
        prizeInfo.prizeTips = '年卡一张,有效期一年'
      }
      if (res.data.prize?.indexOf('沂山风景区') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/18bcf8ddc1820dce9e4f73a4e4f175a7.png'
        prizeInfo.prizeTips = '年卡一张,有效期一年'
      }
      if (res.data.prize?.indexOf('云蒙') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/50f17e089091154ddcc3332ae9586c5c.png'
        prizeInfo.prizeTips = '年卡一张,有效期一年'
      }
      if (res.data.prize?.indexOf('泰山') !== -1) {
        prizeInfo.img =
          '//img11.iqilu.com/29/2022/10/14/0cfffac0a2e777bd770873c5df0a7b13.jpg'
        prizeInfo.prizeTips = '门票一张,有效期一年'
      }
    }
    loading.value = false
  }

  fetchPrizeInfo()

  watch(
    () => store.getters.getToken,
    () => {
      fetchPrizeInfo()
    }
  )

  return {
    prizeInfo,
    loading,
    fetchPrizeInfo,
  }
}

// 选择奖品
const useShowChooesRewardEffect = (fetchPrizeInfo) => {
  const showReward = ref(false)

  const handleChooseReward = () => {
    showReward.value = false
    console.log('---')
    fetchPrizeInfo()
  }

  return {
    showReward,
    handleChooseReward,
  }
}

// 领取奖品 填写信息
const useReceiveRewardEffect = () => {
  const showReceive = ref(false)

  const handleReceived = () => {
    showReceive.value = false
    window.location.reload()
  }

  return {
    showReceive,
    handleReceived,
  }
}
